import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MINI_NAME = '颗粒日记真复习';
function miniProgramUrl() {
  try {
    const url = new URL(String(import.meta.env.VITE_KELIRIJI_MINIPROGRAM_URL || ''));
    return url.protocol === 'https:' ? url.href : '';
  } catch { return ''; }
}

export function JoinContinuePage() {
  const location = useLocation();
  const registered = (location.state as { registered?: boolean } | null)?.registered === true;
  const [copyMessage, setCopyMessage] = useState('');
  const miniUrl = miniProgramUrl();
  async function copyName() {
    try { await navigator.clipboard.writeText(MINI_NAME); setCopyMessage('已复制。打开微信，在小程序中粘贴搜索即可。'); }
    catch { setCopyMessage('请在微信小程序中搜索：颗粒日记真复习'); }
  }
  return <main className="mx-auto max-w-xl px-6 py-16 text-ink">
    <p className="text-sm font-semibold text-primary">颗粒日记·让复习真正发生！</p>
    <h1 className="mt-5 text-3xl font-bold">{registered ? '注册成功，开始你的复习之旅' : '选择你喜欢的方式，继续复习'}</h1>
    <p className="mt-5 leading-7 text-muted">{registered ? '账户已创建。' : ''}在 App 或微信小程序中使用同一手机号登录，即可开始使用。</p>
    <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
      <h2 className="text-xl font-semibold">使用颗粒日记 App</h2>
      <Link to="/download" className="mt-5 block rounded-xl bg-primary px-4 py-4 text-center font-semibold text-white">下载颗粒日记 App</Link>
    </section>
    <section className="mt-5 rounded-2xl border border-slate-200 bg-white p-6">
      <h2 className="text-xl font-semibold">使用微信小程序</h2>
      <p className="mt-4 leading-7">打开微信 → 搜索 → 小程序 → <strong>{MINI_NAME}</strong></p>
      {miniUrl && <a href={miniUrl} className="mt-5 block rounded-xl bg-primary px-4 py-4 text-center font-semibold text-white">打开微信小程序</a>}
      <button type="button" onClick={() => void copyName()} className="mt-4 w-full rounded-xl border border-slate-300 px-4 py-3">复制小程序名称</button>
      {copyMessage && <p role="status" className="mt-3 text-sm text-muted">{copyMessage}</p>}
      {miniUrl && <p className="mt-3 text-sm text-muted">如果未能打开，请使用上方名称在微信中搜索。</p>}
    </section>
    <Link to="/" className="mt-8 inline-block text-primary">继续使用网页版 →</Link>
  </main>;
}
